import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "backdrop"]

  connect() {
    this.sync()
  }

  sync() {
    const text = this.textareaTarget.value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\{([A-Za-z]+(?:[+-]\d+)?)\}/g, '<mark class="placeholder-highlight__token">{$1}</mark>')
    this.backdropTarget.innerHTML = text
  }
}
